import React from 'react';

// @ts-ignore
import glaz from '../../../assets/pictures/projects/software/glaz.mp4';
import VideoAsset from '../../general/VideoAsset';
export interface ArtProjectsProps {}

const ArtProjects: React.FC<ArtProjectsProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Art & Design</h1>
            <h3>Endeavors</h3>
            <br />
            <div className="text-block">
                <p>
                    While I love programming and software development, Art,
                    Design, and Animation will always hold a special place in my
                    heart.
                </p>
                <br />
                <p>
                    Here are a few projects/things I've done over the years to
                    keep the artistic side of me alive. I'm always looking to
                    push myself creatively and learn new things.
                </p>
            </div>
            <div className="text-block">
                     <div className="text-block">
                <h2>Localization Project Lead</h2>
                <br />
                <p>
                    I managed complex localization lifecycles for AAA games (e.g., The Callisto Protocol, Rainbow Six Siege) and acted as a strategic link between global development studios and local production teams. I orchestrated cross-functional workflows for high-budget IP launches, coordinating remote teams of voice actors, engineers, and language specialists under strict confidentiality agreements and deadline constraints. I implemented rigorous quality assurance protocols to ensure 100% compliance with global brand guidelines. I managed the seamless integration of creative assets with the cultural nuances of the Turkish market without compromising the original product vision. I proactively identified operational bottlenecks in remote production processes and implemented agile solutions to ensure timely delivery for synchronized global product launches.{' '}
                </p>
                <br />
                <div className="captioned-image">
                    <VideoAsset src={glaz} />
                        <sub>
                            <b>Figure 2:</b> Operator Scene of the Tom Clancy's Rainbow Six Siege.
                        </sub>
                                    <br />
                <h3>Links:</h3>
                <ul>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://drive.google.com/file/d/1K29s3IEy4GLlgyvMA6C_travIhYVfuAP/view"
                        >
                            <p>
                                <b>[The Callisto Protocol]</b> Live-Action Spot
                            </p>
                        </a>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="https://drive.google.com/file/d/1de6lPtYtbppOV89nPdvMo1nbqfNm3NAE/view"
                        >
                            <p>
                                <b>[Tom Clancy's Rainbow Six Siege]</b> Operator Glaz
                            </p>
                        </a>
                </ul>
                </div>
            </div>
           
            </div>
        </div>
    );
};

export default ArtProjects;
